import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import CandidatosPage from './components/CandidatosPage';

function App() {
  return (
    <div className='App'>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<LandingPage />} />
          <Route path='/candidatos' element={<CandidatosPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
